module.exports = __webpack_public_path__ + "assets/img/warrior-name-2675e6e9.png";